import { api, unwrap } from '../apiClient';
import { tokenStore } from '../tokenStore';
import type { AuthUser } from '@/domain/types';

interface LoginResponse extends Record<string, unknown> {
  user: AuthUser;
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export const authApi = {
  async login(username: string, password: string): Promise<AuthUser> {
    const result = await unwrap<LoginResponse>(
      api.post('/auth/login', {
        username,
        password,
        deviceId: tokenStore.deviceId(),
        deviceLabel: navigator.userAgent.slice(0, 140),
      }),
    );

    tokenStore.set(result.accessToken, result.refreshToken);
    return result.user;
  },

  me(): Promise<AuthUser> {
    return unwrap<AuthUser>(api.get('/auth/me'));
  },

  async logout(): Promise<void> {
    const refreshToken = tokenStore.getRefresh();
    try {
      // Best effort: if the server is unreachable, the local session still
      // ends. Leaving the user "signed in" because logout 500'd is worse.
      if (refreshToken) await api.post('/auth/logout', { refreshToken });
    } finally {
      tokenStore.clear();
    }
  },

  changePassword(currentPassword: string, newPassword: string): Promise<{ message: string }> {
    return unwrap(api.post('/auth/change-password', { currentPassword, newPassword }));
  },
};
